module.exports = __webpack_public_path__ + "img/06_bohle.95262030.png";